import { useSelector } from "react-redux";
import { Container, Row, Column, Col } from "reactstrap";
import BaseHeading from "../../../../baseComponents/baseHeading";
import BaseParagraph from "../../../../baseComponents/baseParagraph";
import useColors from "../../../../customHooks/useColors";
import Card from "../../../../components/Card";

const MyCardLeftSide = () => {
  //////////////////////////////////////////////theme
  const [currentColors] = useColors();

  //////////////////////////////////////////////redux states
  const userState = useSelector((state) => state.userState);

  //////////////////////////////////////////////state driven variables
  const virtualCards = userState.virtualCards;
  const virtualCardsNumber = virtualCards.length;
  const customerHasVirtualCards = virtualCardsNumber > 0;

  const physicalCards = userState.physicalCards;
  const physicalCardsNumber = physicalCards.length;
  const customerHasPhysicalCards = physicalCardsNumber > 0;

  //STYLE
  const styles = {
    mainContainer: {
      backgroundColor: currentColors.septenary,
      padding: "1em",
      display: "flex",
      flexDirection: "column",
      gap: "1em",
      boxShadow:
        "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
      marginBottom: "50px",
    },
  };

  return (
    <Container fluid className="p-0" style={{ marginTop: "1em" }}>
      <Row className="g-0">
        <Col>
          <div style={styles.mainContainer}>
            <BaseHeading h3 bold style={{ color: currentColors.primary }}>
              yourVirtualCard
            </BaseHeading>
            {customerHasVirtualCards && (
              <>
                <BaseParagraph>showCardMessage</BaseParagraph>
                {virtualCards.Emap((card, index, array, isLast) => {
                  return (
                    <Card
                      key={card.card_number}
                      code={card.card_number}
                      hasBorderBottom={!isLast}
                    />
                  );
                })}
              </>
            )}
            {!customerHasVirtualCards && (
              <BaseParagraph>noVirtualCards</BaseParagraph>
            )}
          </div>

          {customerHasPhysicalCards && (
            <div style={styles.mainContainer}>
              <BaseHeading h3 bold style={{ color: currentColors.primary }}>
                yourPhysicalCard
              </BaseHeading>
              <BaseParagraph>showCardMessage</BaseParagraph>
              {physicalCards.Emap((card, index, array, isLast) => {
                return (
                  <Card
                    key={card.card_number}
                    code={card.card_number}
                    hasBorderBottom={!isLast}
                  />
                );
              })}
              
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default MyCardLeftSide;
